import Imgs from "./imgs";

const Constants = {
    Imgs
}

export default Constants;